import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '../../store';
import { loadResponseOptionGroups } from '../../store/ResponseOptionGroupSlice';
import { useSurveyDefaultCultureCode } from './useSurveyDefaultCultureCode';

const useResponseOptionGroups = () => {
	const dispatch = useDispatch();
	const surveyDefaultCultureCode = useSurveyDefaultCultureCode();

	useEffect(() => {
		dispatch(loadResponseOptionGroups(surveyDefaultCultureCode));
	}, [dispatch, loadResponseOptionGroups]);

	return useSelector((state: IApplicationState) => state.responseOptionGroup);
};

export default useResponseOptionGroups;
